import React from 'react';
import { FolderIcon, UnfiledIcon } from '../../../Sidebar/icons';
import AtlasFolderName from './AtlasFolderName';
import './AtlasFolderNode.css';

const AtlasFolderNode = ({
  node,
  live,
  expanded,
  selected,
  dragging,
  dropTarget,
  dropInsert = null,
  registerNode,
  onPointerDown,
  onDragOver,
  onDragLeave,
  onDrop,
  onClick,
  onContextMenu,
  renaming,
  onRenameCommit,
  onRenameCancel,
}) => {
  const unfiled = node.kind === 'unfiled';
  const docCount = node.docCount || 0;
  return (
    <div
      ref={registerNode(node.id)}
      data-atlas-no-pan
      data-atlas-folder-id={node.id}
      className={[
        'atlas__node',
        unfiled ? 'atlas__node--unfiled' : '',
        expanded ? 'atlas__node--expanded' : '',
        selected ? 'atlas__node--selected' : '',
        dragging ? 'atlas__node--dragging' : '',
        dropTarget ? 'atlas__node--drop' : '',
        dropInsert ? `atlas__node--insert-${dropInsert}` : '',
      ]
        .filter(Boolean)
        .join(' ')}
      style={{
        width: node.width,
        transform: `translate(${(live || node).x}px, ${(live || node).y}px)`,
      }}
      onPointerDown={(e) => onPointerDown(e, node.id)}
      onDragOver={(e) => onDragOver(e, node.id)}
      onDragLeave={onDragLeave}
      onDrop={(e) => onDrop(e, node.id)}
      onClick={(e) => onClick(e, node.id)}
      onContextMenu={(e) => onContextMenu(e, node.id)}
    >
      {dropInsert && (
        <span className={`atlas__node-insert atlas__node-insert--${dropInsert}`} aria-hidden />
      )}
      <span className="atlas__node-icon" data-atlas-icon aria-hidden>
        {unfiled ? <UnfiledIcon size={48} /> : <FolderIcon size={48} open={expanded} />}
      </span>
      <span className="atlas__node-text">
        {unfiled ? (
          <span className="atlas__node-name" title={node.name}>{node.name}</span>
        ) : (
          <AtlasFolderName
            folderId={node.id}
            name={node.name}
            onRename={onRenameCommit}
            isEditingTitle={renaming}
            onFinishEdit={onRenameCancel}
          />
        )}
        <span className={`atlas__node-meta${docCount === 0 ? ' atlas__node-meta--empty' : ''}`}>
          <span className="atlas__node-meta-n">{docCount}</span>
          {docCount === 1 ? 'doc' : 'docs'}
        </span>
      </span>
    </div>
  );
};

export default AtlasFolderNode;
